import {
  retrieveReportsMatterSettlementReport,
  type RetrieveReportsMatterSettlementReportInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsMatterSettlementReportQueryOptions = (
  filters: RetrieveReportsMatterSettlementReportInput,
) => ({
  queryKey: [queryKeys.reports, "matter-settlement-report", filters],
  queryFn: () => retrieveReportsMatterSettlementReport(filters),
});
